import {Injectable} from '@angular/core';
import {proposalsEmailUrl, proposalsStatusUrl, proposalsUrl} from '../api-url';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class ProposalService {
    respMsg;

    constructor(private http: HttpClient, private router: Router) {
    }

    getProposals() {
        return this.http.get<any[]>(proposalsUrl);
    }

    getUserProposals(id) {
        return this.http.get<any[]>(`{proposalsUserUrl}/` + id);
    }

    getProposal(id: string) {
        return this.http.get <any>(`${proposalsUrl}/` + id);
    }

    postProposal(proposal) {
        this.http
            .post(`${proposalsUrl}/`, proposal)
            .subscribe(responseData => {
                console.log('POST Proposal', responseData);
                this.router.navigate(['/']);
            });
    }

    submitEmailProposal(proposal) {
        this.http
            .post(`${proposalsEmailUrl}/`, proposal)
            .subscribe(responseData => {
                console.log('POST Proposal', responseData);
                this.router.navigate(['/']);
            });
    }

    approveEmailProposal(proposal) {
        this.http
            .post(`${proposalsStatusUrl}/`, proposal
            )
            .subscribe(responseData => {
                console.log('POST Proposal', responseData);
                this.router.navigate(['/']);
            });
    }

    deleteProposal(proposalId) {
        this.http.delete(`${proposalsUrl}/` + proposalId)
            .subscribe(response => {
                console.log('PROPOSAL DELETE RESPONSE', response);
                // this.respMsg = response;
                this.router.navigate(['/']);
            });
    }

    editProposal(proposalId, proposal) {
        this.http
            .put(`${proposalsUrl}/` + proposalId, proposal)
            .subscribe(response => {
                console.log('UPDATED PROPOSAL RESPONSE', response);
                this.router.navigate(['/app/proposals']);
            });
    }
}
